// import { Mic, MicOff } from 'lucide-react'
// import React, { useEffect, useState } from 'react'
// import env from '../../config/configuration'
// import Layout from '../Layout'
// import { useAgent } from './agent.context'
// import ChatContainer from './chat'

// export default function Phone() {
//   const { loading: loadingAgent, agent } = useAgent()
//   const [chat, setChat] = useState([])
//   const [isCalling, setIsCalling] = useState(false)
//   const [loading, setLoading] = useState(false)
//   const [error, setError] = useState(null)
//   const [callId, setCallId] = useState(null)
//   const [transcript, setTranscript] = useState('')
//   const [callStatus, setCallStatus] = useState('idle')
//   const userAgentInfo = JSON.parse(localStorage.getItem('agent'))

//   console.log('User Agent Info:', userAgentInfo)

//   const createPhoneCall = async () => {
//     try {
//       const response = await fetch(
//         'https://api.retellai.com/v2/create-phone-call',
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${env.RETELL_API}`,
//           },
//           body: JSON.stringify({
//             from_number: '+13212169799',
//             // to_number: userAgentInfo.userData?.telephone,
//             to_number: '+18173258857',
//             override_agent_id: agent.agent_id,
//           }),
//         }
//       )

//       if (!response.ok) {
//         throw new Error('Network response was not ok')
//       }

//       const data = await response.json()
//       console.log('Web call created successfully:', data)
//       return data
//     } catch (err) {
//       setError(err.message)
//       console.error('Error creating web call:', err)
//     } finally {
//       setLoading(false)
//     }
//   }

//   const deletePhoneCall = async () => {
//     try {
//       const response = await fetch(
//         'https://api.retellai.com/v2/delete-call/' + callId,
//         {
//           method: 'DELETE',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${env.RETELL_API}`,
//           },
//         }
//       )

//       if (!response.ok) {
//         throw new Error('Network response was not ok')
//       }

//       const data = await response.json()
//       console.log('Web call deleted successfully:', data)
//       return data
//     } catch (err) {
//       setError(err.message)
//       console.error('Error creating web call:', err)
//     }
//   }

//   const toggleConversation = async (e) => {
//     e.preventDefault()
//     setLoading(true)
//     setError(null)
//     if (isCalling) {
//       deletePhoneCall()
//       setLoading(false)
//       setIsCalling(false)
//     } else {
//       const registerCallResponse = await createPhoneCall()
//       if (registerCallResponse) {
//         console.log('Response', registerCallResponse)

//         setCallId(registerCallResponse.call_id)
//         setCallStatus('active')
//         setTranscript('Call started. Waiting for transcript...\n')

//         setIsCalling(true) // Update button to "Stop" when conversation starts
//         setLoading(false)
//       }
//     }
//   }

//   // Poll the call for updates
//   const pollCall = async () => {
//     if (!callId || callStatus === 'ended' || callStatus == 'error') return

//     try {
//       const response = await fetch(
//         `https://api.retellai.com/v2/get-call/${callId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${env.RETELL_API}`,
//           },
//         }
//       )
//       const callData = await response.json()

//       if (callData.transcript_object) {
//         const transcriptText = callData.transcript_object
//           .map((entry) => `${entry.role}: ${entry.content}`)
//           .join('\n')
//         setTranscript(transcriptText)
//       }

//       if (callData.call_status === 'ended') {
//         setCallStatus('ended')
//         setTranscript((prev) => prev + '\nCall ended.')
//       }
//     } catch (error) {
//       console.error('Error polling call:', error)
//       setTranscript('Error fetching transcript.')
//       setCallStatus('error')
//     }
//   }

//   // Set up polling when call is active
//   useEffect(() => {
//     let intervalId
//     if (callStatus === 'active' && callId) {
//       intervalId = setInterval(pollCall, 2000) // Poll every 2 seconds
//     }
//     return () => {
//       if (intervalId) clearInterval(intervalId) // Cleanup on unmount or status change
//     }
//   }, [callStatus, callId])

//   return (
//     <Layout>
//       <div className='max-w-7xl mx-auto'>
//         <div className='flex justify-center items-center h-[calc(100vh-330px)] flex-col'>
//           <div className='grid md:grid-cols-2 items-end gap-12'>
//             <div className='min-h-[360px] flex items-end flex-col'>
//               <div className='w-full'>
//                 <button
//                   type='submit'
//                   onClick={toggleConversation}
//                   className={`w-full border ${
//                     loadingAgent && !agent
//                       ? 'opacity-60 cursor-not-allowed'
//                       : 'hover:from-[#065EDA] hover:to-[#054CA8]'
//                   } border-white py-3 font-semibold rounded-full transition duration-300 bg-gradient-to-b from-[#0874E2] to-[#065EDA] text-white flex items-center justify-center gap-2`}
//                   disabled={loadingAgent && !agent}
//                 >
//                   Phone
//                   {loading ? (
//                     <>Processing...</>
//                   ) : (
//                     <>{isCalling ? <MicOff size={20} /> : <Mic size={20} />}</>
//                   )}
//                 </button>
//               </div>
//             </div>

//             <div className='hidden md:block'>
//               <ChatContainer chat={chat} />
//             </div>
//           </div>
//         </div>
//       </div>
//     </Layout>
//   )
// }



import { Clock, MessageCircle, Phone as PhoneIcon, PhoneOff } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import env from '../../config/configuration'
import Layout from '../Layout'
import { useAgent } from './agent.context'
import ChatContainer from './chat'

function PhoneMockup({ isCalling, isAgentTalking, callStatus, onAccept, onDecline }) {
  const [callDuration, setCallDuration] = useState(0)
  const [isRinging, setIsRinging] = useState(true)

  useEffect(() => {
    let interval
    if (isCalling && callStatus === 'active') {
      interval = setInterval(() => {
        setCallDuration(prev => prev + 1)
      }, 1000)
      setIsRinging(false)
    } else if (isCalling && callStatus === 'connecting') {
      setIsRinging(true)
    } else if (callStatus === 'idle') {
      setIsRinging(true)
    } else {
      setCallDuration(0)
      setIsRinging(false)
    }
    return () => clearInterval(interval)
  }, [isCalling, callStatus])

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  }

  const showIncomingCallScreen = isRinging || callStatus === 'idle'
  
  const getDynamicIslandClasses = () => {
    if (callStatus === 'active' && isAgentTalking) {
      return 'w-36 h-8 rounded-full bg-black transition-all duration-300 flex items-center shadow-md'
    } else if (callStatus === 'active') {
      return 'w-28 h-7 rounded-full bg-black transition-all duration-300 shadow-sm'
    } else {
      return 'w-24 h-6 rounded-full bg-black transition-all duration-300 shadow-sm'
    }
  }

  return (
    <div className="relative mx-auto bg-gray-900 border-[4px] border-gray-800 rounded-[2.75rem] h-[540px] w-[260px] shadow-2xl">
      {/* Side Buttons */}
      <div className="h-[30px] w-[1.5px] bg-gray-700 absolute -left-[1.5px] top-[80px] rounded-l-md"></div>
      <div className="h-[45px] w-[1.5px] bg-gray-700 absolute -left-[1.5px] top-[120px] rounded-l-md"></div>
      <div className="h-[45px] w-[1.5px] bg-gray-700 absolute -left-[1.5px] top-[170px] rounded-l-md"></div>
      <div className="h-[60px] w-[1.5px] bg-gray-700 absolute -right-[1.5px] top-[130px] rounded-r-md"></div>
      
      <div className="rounded-[2.5rem] overflow-hidden w-[252px] h-[532px] bg-black">
        {/* Dynamic Island */}
        <div className="absolute left-1/2 transform -translate-x-1/2 top-2 z-10 flex justify-center">
          <div className={getDynamicIslandClasses()}>
            {callStatus === 'active' && isAgentTalking && (
              <div className="px-3 flex items-center justify-between w-full">
                <div className="flex items-center">
                  <div className="w-2 h-2 rounded-full bg-green-400 mr-2 animate-pulse"></div>
                  <span className="text-white text-xs font-medium">GABBI</span>
                </div>
                <span className="text-white text-xs">{formatTime(callDuration)}</span>
              </div>
            )}
          </div>
        </div>
        
        <div className="h-full flex flex-col bg-gradient-to-b from-gray-900 to-black relative">
          {showIncomingCallScreen ? (
            <div className="h-full flex flex-col items-center justify-between p-4 text-white">
              <div className="mt-16 text-center">
                <h2 className="text-2xl font-semibold mb-1 tracking-tight">GABBI</h2>
                <p className="text-gray-400 text-sm">Incoming Call</p>
                <div className="mt-10 flex items-center justify-center">
                  <svg className="w-28 h-28" viewBox="0 0 100 100">
                    <g stroke="white" fill="none" strokeWidth="1.5" opacity="0.9">
                      <circle cx="50" cy="50" r="8" fill="white" />
                      <circle cx="30" cy="30" r="3" fill="white" />
                      <circle cx="40" cy="20" r="2" fill="white" />
                      <circle cx="20" cy="40" r="2" fill="white" />
                      <circle cx="25" cy="60" r="2" fill="white" />
                      <circle cx="35" cy="70" r="3" fill="white" />
                      <circle cx="55" cy="75" r="2" fill="white" />
                      <circle cx="70" cy="60" r="3" fill="white" />
                      <circle cx="75" cy="40" r="2" fill="white" />
                      <circle cx="65" cy="25" r="2" fill="white" />
                      <path d="M50,50 L30,30" />
                      <path d="M50,50 L40,20" />
                      <path d="M50,50 L20,40" />
                      <path d="M50,50 L25,60" />
                      <path d="M50,50 L35,70" />
                      <path d="M50,50 L55,75" />
                      <path d="M50,50 L70,60" />
                      <path d="M50,50 L75,40" />
                      <path d="M50,50 L65,25" />
                      <path d="M30,30 L40,20" />
                      <path d="M40,20 L65,25" />
                      <path d="M65,25 L75,40" />
                      <path d="M75,40 L70,60" />
                      <path d="M70,60 L55,75" />
                      <path d="M55,75 L35,70" />
                      <path d="M35,70 L25,60" />
                      <path d="M25,60 L20,40" />
                      <path d="M20,40 L30,30" />
                    </g>
                  </svg>
                </div>
              </div>
              
              <div className="mb-8 w-full">
                <div className="flex justify-between px-8 mb-6">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 rounded-full bg-gray-800/80 flex items-center justify-center mb-1 shadow-sm">
                      <Clock className="h-5 w-5 text-gray-300" />
                    </div>
                    <span className="text-xs text-gray-300">Remind</span>
                  </div>
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 rounded-full bg-gray-800/80 flex items-center justify-center mb-1 shadow-sm">
                      <MessageCircle className="h-5 w-5 text-gray-300" />
                    </div>
                    <span className="text-xs text-gray-300">Message</span>
                  </div>
                </div>
                
                <div className="flex justify-between px-6">
                  <button
                    onClick={onDecline}
                    className="w-14 h-14 rounded-full bg-red-500/90 flex items-center justify-center shadow-lg hover:bg-red-600 transition-colors"
                  >
                    <PhoneOff className="h-6 w-6 text-white" />
                  </button>
                  <button
                    onClick={onAccept}
                    className="w-14 h-14 rounded-full bg-green-500/90 flex items-center justify-center shadow-lg hover:bg-green-600 transition-colors"
                  >
                    <PhoneIcon className="h-6 w-6 text-white" />
                  </button>
                </div>
              </div>
            </div>
          ) : isCalling ? (
            <div className="h-full flex flex-col items-center justify-between p-4 text-white">
              <div className="mt-16 text-center">
                <h2 className="text-2xl font-semibold mb-1 tracking-tight">GABBI</h2>
                <p className="text-gray-400 text-sm">
                  {callStatus === 'active' ? formatTime(callDuration) : 'Connecting...'}
                </p>
                
                <div className="mt-10 flex items-center justify-center">
                  <div className={`w-28 h-28 flex items-center justify-center 
                    ${isAgentTalking ? 'animate-pulse' : ''}`}>
                    <svg className="w-24 h-24" viewBox="0 0 100 100">
                      <g stroke="white" fill="none" strokeWidth="1.5" opacity="0.9">
                        <circle cx="50" cy="50" r="8" fill="white" />
                        <circle cx="30" cy="30" r="3" fill="white" />
                        <circle cx="40" cy="20" r="2" fill="white" />
                        <circle cx="20" cy="40" r="2" fill="white" />
                        <circle cx="25" cy="60" r="2" fill="white" />
                        <circle cx="35" cy="70" r="3" fill="white" />
                        <circle cx="55" cy="75" r="2" fill="white" />
                        <circle cx="70" cy="60" r="3" fill="white" />
                        <circle cx="75" cy="40" r="2" fill="white" />
                        <circle cx="65" cy="25" r="2" fill="white" />
                        <path d="M50,50 L30,30" />
                        <path d="M50,50 L40,20" />
                        <path d="M50,50 L20,40" />
                        <path d="M50,50 L25,60" />
                        <path d="M50,50 L35,70" />
                        <path d="M50,50 L55,75" />
                        <path d="M50,50 L70,60" />
                        <path d="M50,50 L75,40" />
                        <path d="M50,50 L65,25" />
                        <path d="M30,30 L40,20" />
                        <path d="M40,20 L65,25" />
                        <path d="M65,25 L75,40" />
                        <path d="M75,40 L70,60" />
                        <path d="M70,60 L55,75" />
                        <path d="M55,75 L35,70" />
                        <path d="M35,70 L25,60" />
                        <path d="M25,60 L20,40" />
                        <path d="M20,40 L30,30" />
                      </g>
                    </svg>
                  </div>
                </div>
                
                {isAgentTalking && <p className="text-xs text-blue-300 mt-4">Agent is speaking...</p>}
              </div>
              
              <div className="mb-12">
                <button
                  onClick={onDecline}
                  className="w-14 h-14 rounded-full bg-red-500/90 flex items-center justify-center shadow-lg hover:bg-red-600 transition-colors"
                >
                  <PhoneOff className="h-6 w-6 text-white" />
                </button>
              </div>
            </div>
          ) : (
            <div className="h-full flex flex-col items-center justify-between p-4 text-white">
              <div className="mt-16 text-center">
                <h2 className="text-2xl font-semibold mb-1 tracking-tight">GABBI</h2>
                <p className="text-gray-400 text-sm">Call Ended</p>
                
                <div className="mt-10 flex items-center justify-center opacity-70">
                  <svg className="w-28 h-28" viewBox="0 0 100 100">
                    <g stroke="white" fill="none" strokeWidth="1.5" opacity="0.6">
                      <circle cx="50" cy="50" r="8" fill="white" />
                      <circle cx="30" cy="30" r="3" fill="white" />
                      <circle cx="40" cy="20" r="2" fill="white" />
                      <circle cx="20" cy="40" r="2" fill="white" />
                      <circle cx="25" cy="60" r="2" fill="white" />
                      <circle cx="35" cy="70" r="3" fill="white" />
                      <circle cx="55" cy="75" r="2" fill="white" />
                      <circle cx="70" cy="60" r="3" fill="white" />
                      <circle cx="75" cy="40" r="2" fill="white" />
                      <circle cx="65" cy="25" r="2" fill="white" />
                      <path d="M50,50 L30,30" />
                      <path d="M50,50 L40,20" />
                      <path d="M50,50 L20,40" />
                      <path d="M50,50 L25,60" />
                      <path d="M50,50 L35,70" />
                      <path d="M50,50 L55,75" />
                      <path d="M50,50 L70,60" />
                      <path d="M50,50 L75,40" />
                      <path d="M50,50 L65,25" />
                      <path d="M30,30 L40,20" />
                      <path d="M40,20 L65,25" />
                      <path d="M65,25 L75,40" />
                      <path d="M75,40 L70,60" />
                      <path d="M70,60 L55,75" />
                      <path d="M55,75 L35,70" />
                      <path d="M35,70 L25,60" />
                      <path d="M25,60 L20,40" />
                      <path d="M20,40 L30,30" />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default function PhoneCallInterface() {
  const { loading: loadingAgent, agent } = useAgent()
  const [chat, setChat] = useState([])
  const [isCalling, setIsCalling] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [callId, setCallId] = useState(null)
  const [transcript, setTranscript] = useState('')
  const [callStatus, setCallStatus] = useState('idle')
  const [isAgentTalking, setIsAgentTalking] = useState(false)
  const userAgentInfo = JSON.parse(localStorage.getItem('agent'))

  const createPhoneCall = async () => {
    try {
      const response = await fetch(
        'https://api.retellai.com/v2/create-phone-call',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${env.RETELL_API}`,
          },
          body: JSON.stringify({
            from_number: '+13212169799',
            // to_number: userAgentInfo.userData?.telephone,
            to_number: '+18173258857',
            override_agent_id: agent.agent_id,
          }),
        }
      )

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.message || 'Network response was not ok')
      }

      return await response.json()
    } catch (err) {
      console.error('Error creating phone call:', err)
      setError(err.message)
      throw err
    }
  }

  const deletePhoneCall = async () => {
    try {
      const response = await fetch(
        `https://api.retellai.com/v2/delete-call/${callId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${env.RETELL_API}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error('Failed to end call')
      }
    } catch (err) {
      console.error('Error deleting phone call:', err)
      setError(err.message)
    }
  }

  const acceptCall = async () => {
    setCallStatus('active')
    if (!isCalling) {
      setIsCalling(true)
    }
  }

  const declineCall = async () => {
    setLoading(true)
    try {
      if (callId) {
        await deletePhoneCall()
      }
      setIsCalling(false)
      setIsAgentTalking(false)
      setCallStatus('ended')
    } catch (err) {
      console.error('Error declining call:', err)
    } finally {
      setLoading(false)
    }
  }

  const toggleConversation = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    
    try {
      if (isCalling) {
        await deletePhoneCall()
        setIsCalling(false)
        setIsAgentTalking(false)
        setCallStatus('ended')
      } else {
        const response = await createPhoneCall()
        if (response) {
          setCallId(response.call_id)
          setCallStatus('connecting')
          setIsCalling(true)
          setChat([{ type: 'system', message: 'Call started...' }])
        }
      }
    } catch (err) {
      console.error('Call operation failed:', err)
    } finally {
      setLoading(false)
    }
  }

  const pollCall = async () => {
    if (!callId || callStatus !== 'active') return

    try {
      const response = await fetch(
        `https://api.retellai.com/v2/get-call/${callId}`,
        {
          headers: {
            Authorization: `Bearer ${env.RETELL_API}`,
          },
        }
      )
      
      if (!response.ok) {
        throw new Error('Failed to get call status')
      }

      const callData = await response.json()
      
      if (callData.transcript_object) {
        setTranscript(
          callData.transcript_object
            .map(entry => `${entry.role}: ${entry.content}`)
            .join('\n')
        )
        
        setChat(
          callData.transcript_object.map(entry => ({
            type: entry.role === 'agent' ? 'bot' : 'user',
            message: entry.content
          }))
        )
        
        const lastEntry = callData.transcript_object[callData.transcript_object.length - 1]
        setIsAgentTalking(lastEntry?.role === 'agent' && !lastEntry?.end_timestamp)
      }

      if (callData.call_status === 'ended') {
        setCallStatus('ended')
        setIsCalling(false)
        setIsAgentTalking(false)
      }
    } catch (err) {
      console.error('Error polling call:', err)
      setCallStatus('error')
    }
  }

  useEffect(() => {
    const interval = callStatus === 'active' ? setInterval(pollCall, 2000) : null
    return () => {
      if (interval) clearInterval(interval)
    }
  }, [callStatus, callId])

  return (
    <Layout>
      <div className='max-w-7xl mx-auto'>
        <div className='flex justify-center items-center h-[calc(100vh-330px)] flex-col'>
          <div className='grid md:grid-cols-2 items-end gap-12'>
            <div className='flex flex-col items-center'>
              <div className='flex-grow flex items-center justify-center'>
                <PhoneMockup 
                  isCalling={isCalling} 
                  isAgentTalking={isAgentTalking} 
                  callStatus={callStatus}
                  onAccept={acceptCall}
                  onDecline={declineCall}
                />
              </div>
              
              {callStatus !== 'connecting' && (
                <button
                  onClick={toggleConversation}
                  disabled={loadingAgent || loading}
                  className={`mt-6 w-[220px] py-3 font-semibold rounded-full transition duration-300 bg-[#3498db] text-white flex items-center justify-center gap-2 ${
                    loadingAgent || loading ? 'opacity-60 cursor-not-allowed' : 'hover:bg-[#2980b9]'
                  }`}
                >
                  {loading ? (
                    'Processing...'
                  ) : (
                    <>
                      {isCalling ? 'END CALL' : 'TALK'}
                    </>
                  )}
                </button>
              )}
              
              {error && (
                <p className="text-red-500 mt-2 text-center max-w-[220px]">
                  {error}
                </p>
              )}
            </div>

            <div className='hidden md:block'>
              <ChatContainer chat={chat} />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}